import clsx from 'clsx'
import React, {
  CSSProperties,
  forwardRef,
  ReactNode,
  useImperativeHandle,
  useRef,
} from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { Scrollbars as CustomScrollbars } from 'react-custom-scrollbars-2'

import classes from './styles.module.scss'

export interface ScrollbarRef {
  scrollToTop: () => void
  scrollToPositionTop: (arg: number) => void
  scrollToBottom: () => void
  scrollToPositionLeft: (arg: number) => void
}

export interface IScrollbarsProps {
  noScroll?: boolean
  innerStyle?: CSSProperties
  id?: string
  autoHeight?: boolean
  style?: CSSProperties
  children: ReactNode
  className?: string
  onScroll?: (e: React.UIEvent<HTMLElement>) => void
  scrollBehavior?: 'smooth' | 'auto'
}

const Scrollbars = forwardRef<ScrollbarRef, IScrollbarsProps>(
  (
    {
      children,
      noScroll,
      innerStyle,
      id,
      autoHeight,
      style = {},
      className,
      onScroll,
      scrollBehavior,
    },
    refParent,
  ) => {
    const scrollbar = useRef<any>(null)
    useImperativeHandle(refParent, () => ({
      scrollToTop,
      scrollToPositionTop,
      scrollToBottom,
      scrollToPositionLeft,
    }))

    function scrollToTop() {
      if (scrollbar && scrollbar.current) {
        scrollbar.current.scrollTop(0)
      }
    }

    function scrollToPositionTop(scrollPosition: number) {
      scrollbar.current.scrollTop(scrollPosition)
    }
    function scrollToPositionLeft(scrollPosition: number) {
      scrollbar.current.scrollLeft(scrollPosition)
    }

    function scrollToBottom() {
      scrollbar.current.scrollToBottom()
    }

    if (noScroll) {
      return <>{children}</>
    }

    return (
      <CustomScrollbars
        autoHide
        autoHeight={autoHeight}
        renderView={(props: any) => (
          <div
            {...props}
            id={id}
            className={`${classes.view} ${className}`}
            style={{ ...props.style, ...innerStyle }}
          />
        )}
        renderTrackHorizontal={(props: any) => (
          <div
            {...props}
            style={{ display: 'none' }}
            className={classes.horizontal_track}
          />
        )}
        renderThumbHorizontal={(props: any) => (
          <div {...props} className={classes.horizontal_thumb} />
        )}
        renderThumbVertical={(props: any) => (
          <div {...props} className={classes.vertical_thumb} />
        )}
        className={clsx(classes.inner_list, {
          [classes.scrollInstant]: scrollBehavior === 'auto',
        })}
        ref={scrollbar}
        style={style}
        onScroll={(e) => onScroll && onScroll(e)}
        universal={true}
      >
        {children}
      </CustomScrollbars>
    )
  },
)

Scrollbars.displayName = 'Scrollbars'

export default Scrollbars
